/* BASE TEAM — shared interactions. No dependencies. Safe to load multiple times. */
(function () {
  if (window.BaseTeam) { window.BaseTeam.init(document); return; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  function toast(msg) {
    var t = document.querySelector('.tm-toast');
    if (!t) { t = document.createElement('div'); t.className = 'tm tm-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  function heroes(root) {
    root.querySelectorAll('[data-tm-slides]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var slides = el.querySelectorAll('.tm-hero__slide'), dots = el.querySelectorAll('.tm-hero__dots button');
      if (slides.length < 2) return;
      var i = 0, ms = (parseInt(el.getAttribute('data-tm-slides'), 10) || 6) * 1000, timer;
      function go(n) {
        slides[i].classList.remove('is-active'); if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-current', 'false'); }
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
      }
      function play() { if (reduce) return; clearInterval(timer); timer = setInterval(function () { go(i + 1); }, ms); }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
      el.addEventListener('mouseenter', function () { clearInterval(timer); });
      el.addEventListener('mouseleave', play);
      play();
    });
  }

  function reveal(root) {
    var els = root.querySelectorAll('.tm-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function countUp(root) {
    root.querySelectorAll('[data-tm-count]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var target = parseFloat(el.getAttribute('data-tm-count')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = target.toLocaleString() + suffix; return; }
      var io = new IntersectionObserver(function (ents) {
        if (!ents[0].isIntersecting) return; io.disconnect();
        var start = performance.now(), dur = 1400;
        (function tick(now) {
          var p = Math.min(1, (now - start) / dur), v = Math.round(target * (1 - Math.pow(1 - p, 3)));
          el.textContent = v.toLocaleString() + suffix; if (p < 1) requestAnimationFrame(tick);
        })(start);
      });
      io.observe(el);
    });
  }

  function copy(root) {
    root.querySelectorAll('[data-tm-copy]:not([data-ready])').forEach(function (b) {
      b.setAttribute('data-ready', '');
      b.addEventListener('click', function () {
        var txt = b.getAttribute('data-tm-copy');
        var done = function () { toast((b.getAttribute('data-label') || 'Code') + ' copied'); var o = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = o; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, done);
        else { var t = document.createElement('textarea'); t.value = txt; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} t.remove(); done(); }
      });
    });
    root.querySelectorAll('[data-tm-reveal-code]:not([data-ready])').forEach(function (b) {
      b.setAttribute('data-ready', '');
      b.addEventListener('click', function () {
        var v = b.closest('.tm-code').querySelector('.tm-code__val'); v.classList.toggle('is-hidden');
        b.textContent = v.classList.contains('is-hidden') ? 'Show' : 'Hide';
      });
    });
  }

  function countdowns(root) {
    root.querySelectorAll('[data-tm-countdown]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var t = new Date(el.getAttribute('data-tm-countdown')).getTime();
      if (isNaN(t)) return;
      var u = { d: el.querySelector('[data-u=d]'), h: el.querySelector('[data-u=h]'), m: el.querySelector('[data-u=m]'), s: el.querySelector('[data-u=s]') };
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = Math.max(0, t - Date.now());
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        if (u.d) u.d.textContent = d; if (u.h) u.h.textContent = pad(h); if (u.m) u.m.textContent = pad(m); if (u.s) u.s.textContent = pad(s);
        if (diff <= 0) { el.classList.add('is-done'); var done = el.parentNode.querySelector('[data-tm-countdown-done]'); if (done) done.hidden = false; return; }
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  function checklists(root) {
    root.querySelectorAll('[data-tm-checklist]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var key = 'tm-check:' + el.getAttribute('data-tm-checklist');
      var state = store.get(key, {});
      var boxes = el.querySelectorAll('input[type=checkbox]');
      var bar = el.querySelector('.tm-progress__bar'), label = el.querySelector('[data-tm-progress-label]');
      function update() {
        var n = 0; boxes.forEach(function (b) { if (b.checked) n++; });
        var pct = boxes.length ? Math.round(n / boxes.length * 100) : 0;
        if (bar) bar.style.width = pct + '%';
        if (label) label.textContent = n + ' of ' + boxes.length + ' done';
        if (pct === 100 && !el._celebrated) { el._celebrated = true; toast('Checklist complete — welcome to the team!'); }
      }
      boxes.forEach(function (b) {
        if (state[b.value]) b.checked = true;
        b.addEventListener('change', function () { state[b.value] = b.checked; store.set(key, state); update(); });
      });
      update();
    });
  }

  function lightbox(root) {
    root.querySelectorAll('[data-tm-lightbox]:not([data-ready])').forEach(function (g) {
      g.setAttribute('data-ready', '');
      g.addEventListener('click', function (e) {
        var f = e.target.closest('figure[data-full]'); if (!f) return;
        var lb = document.querySelector('.tm-lightbox');
        if (!lb) {
          lb = document.createElement('div'); lb.className = 'tm tm-lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
          lb.innerHTML = '<img alt=""><button type="button" aria-label="Close">×</button>';
          document.body.appendChild(lb);
          lb.addEventListener('click', function (ev) { if (ev.target === lb || ev.target.tagName === 'BUTTON') lb.classList.remove('is-open'); });
          document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') lb.classList.remove('is-open'); });
        }
        var img = lb.querySelector('img'); img.src = f.getAttribute('data-full'); img.alt = f.getAttribute('data-alt') || '';
        lb.classList.add('is-open'); lb.querySelector('button').focus();
      });
      g.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('figure[data-full]')) e.target.click(); });
    });
  }

  function forms(root) {
    // multi-select pills -> one hidden field (contact forms only keep the last value of a repeated name)
    root.querySelectorAll('[data-tm-multi]:not([data-ready])').forEach(function (fs) {
      fs.setAttribute('data-ready', '');
      var hidden = fs.querySelector('input[type=hidden]');
      fs.addEventListener('change', function () {
        var v = []; fs.querySelectorAll('input[type=checkbox]:checked').forEach(function (c) { v.push(c.value); });
        hidden.value = v.join(', ');
      });
    });
    root.querySelectorAll('[data-tm-draft]:not([data-ready])').forEach(function (w) {
      w.setAttribute('data-ready', '');
      var f = w.tagName === 'FORM' ? w : w.querySelector('form'); if (!f) return;
      var key = 'tm-draft:' + w.getAttribute('data-tm-draft');
      var d = store.get(key, {});
      f.querySelectorAll('input[type=text],input[type=email],input[type=tel],input[type=url],textarea,select').forEach(function (i) {
        if (d[i.name] && !i.value) i.value = d[i.name];
        i.addEventListener('input', function () { d[i.name] = i.value; store.set(key, d); });
      });
      f.addEventListener('submit', function () { store.set(key, {}); });
    });
  }

  function icsDate(d, allDay) {
    function p(n) { return (n < 10 ? '0' : '') + n; }
    if (allDay) return d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate());
    return d.getUTCFullYear() + p(d.getUTCMonth() + 1) + p(d.getUTCDate()) + 'T' + p(d.getUTCHours()) + p(d.getUTCMinutes()) + '00Z';
  }
  function downloadIcs(o) {
    var allDay = /^\d{4}-\d{2}-\d{2}$/.test(String(o.start).trim());
    var start = allDay ? (function (p) { return new Date(+p[0], p[1] - 1, +p[2]); })(String(o.start).trim().split('-')) : new Date(o.start);
    if (isNaN(start)) return;
    var end = new Date(start.getTime() + (allDay ? 864e5 : 3 * 36e5));
    var esc = function (s) { return String(s || '').replace(/[,;\\]/g, '\\$&').replace(/\n/g, '\\n'); };
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//BASE Team//EN', 'BEGIN:VEVENT',
      'UID:' + Date.now() + '@baseteam', 'DTSTAMP:' + icsDate(new Date(), false),
      (allDay ? 'DTSTART;VALUE=DATE:' : 'DTSTART:') + icsDate(start, allDay),
      (allDay ? 'DTEND;VALUE=DATE:' : 'DTEND:') + icsDate(end, allDay),
      'SUMMARY:' + esc(o.title), 'LOCATION:' + esc(o.location), 'URL:' + esc(o.url || location.href), 'END:VEVENT', 'END:VCALENDAR'];
    var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar' });
    var a = document.createElement('a'); a.href = URL.createObjectURL(blob);
    a.download = (o.title || 'event').replace(/[^a-z0-9]+/gi, '-').toLowerCase() + '.ics';
    document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 500);
    toast('Saved to your calendar');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tm-ics]'); if (!b) return;
    downloadIcs({ title: b.getAttribute('data-title'), start: b.getAttribute('data-start'), location: b.getAttribute('data-location'), url: b.getAttribute('data-url') });
  });

  // Membership level buttons pre-select the level on the application form
  function selectLevel(level) {
    var sel = document.getElementById('ta-tier'); if (!sel || !level) return;
    var want = String(level).trim().toLowerCase();
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].text.trim().toLowerCase() === want) { sel.selectedIndex = i; sel.dispatchEvent(new Event('input', { bubbles: true })); sel.dispatchEvent(new Event('change', { bubbles: true })); break; }
    }
  }
  function headerOffset() {
    var h = document.querySelector('.site-header, #HeaderWrapper, .header-wrapper, [data-section-type="header"]');
    var bar = document.querySelector('.announcement-bar');
    var off = 16;
    if (h && getComputedStyle(h).position !== 'static') off += h.getBoundingClientRect().height;
    if (bar && bar.getBoundingClientRect().top <= 0 && getComputedStyle(bar).position !== 'static') off += bar.getBoundingClientRect().height;
    return off;
  }
  function jumpTo(id) {
    var t = id && document.getElementById(id); if (!t) return false;
    var top = t.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, top); }
    try { history.replaceState(null, '', '#' + id); } catch (err) {}
    return true;
  }
  /* Handle in-page links (#apply, #tiers, #codes...) ourselves so theme page-transition scripts can't swallow the click */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var href = a.getAttribute('href') || '';
    var level = a.getAttribute('data-tm-level');
    var hash = '';
    if (href.charAt(0) === '#') hash = href.slice(1);
    else if (href.indexOf('/#') === 0 && (location.pathname === '/' || location.pathname === '')) hash = href.slice(2);
    if (hash && document.getElementById(hash)) {
      e.preventDefault(); e.stopImmediatePropagation();
      jumpTo(hash);
      if (level) setTimeout(function () { selectLevel(level); }, 50);
      return;
    }
    if (level) selectLevel(level);
  }, true);
  if (location.hash && location.hash.length > 1) { window.addEventListener('load', function () { setTimeout(function () { jumpTo(location.hash.slice(1)); }, 150); }); }
  (function () {
    var m = /[?&]level=([^&#]+)/.exec(location.search);
    if (m) { var go = function () { selectLevel(decodeURIComponent(m[1].replace(/\+/g, ' '))); }; if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go(); }
  })();

  function init(root) {
    root = root || document;
    heroes(root); reveal(root); countUp(root); copy(root); countdowns(root); checklists(root); lightbox(root); forms(root);
  }

  window.BaseTeam = { init: init, toast: toast, store: store, ics: downloadIcs };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
